"use strict";
// packages/contracts/src/cep.ts — Fase 09, Plano 02 (CAD-01, D-09..D-12).
//
// Contrato allowlisted e discriminado para o resultado de consulta de CEP (COVERAGE.md).
// Somente o estado ENCONTRADO carrega dados de endereço, e somente os quatro campos de
// D-10 (logradouro, bairro, cidade, UF) — número e complemento nunca vêm do provedor.
// Nenhum outro campo de provedor (URL, geolocalização, IBGE, DDD, etc.) atravessa este
// contrato: o adapter descarta tudo que não seja explicitamente listado aqui.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=cep.js.map